var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuBranding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3493 10.3333L11.9051 10.0217C12.1301 9.97741 12.337 9.86784 12.5001 9.70666L17.0434 5.16666C17.6525 4.55719 17.6525 3.56945 17.0434 2.95999V2.95999C16.434 2.3509 15.4462 2.3509 14.8368 2.95999L10.2934 7.49999C10.131 7.66263 10.0203 7.86963 9.97509 8.09499L9.66676 9.65082C9.63046 9.84067 9.69056 10.0362 9.82724 10.1728C9.96391 10.3095 10.1594 10.3696 10.3493 10.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8042 12.02C10.4075 14.6234 13.9709 15.2834 15.7584 13.4934C17.265 11.9867 17.0309 9.22671 15.3684 6.83838",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 4.59311C10.0692 2.18478 6.15418 1.88394 3.97334 4.06478C1.53251 6.50561 2.19251 11.1223 5.44668 14.3764C6.87155 15.8248 8.63284 16.8978 10.5733 17.4998",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuBranding);
export default ForwardRef;